export const DOCUMENT_PANEL_SEGMENTS = [
  'chapters',
  'analysis',
  'storylines',
  'scenes',
  'characters',
  'locations',
  'technical-sheet',
  'export',
  'share',
  'version-history',
  'stats',
  'settings',
  'suggestions',
  'comments',
  'chat',
] as const;

export type DocumentPanelSegment = (typeof DOCUMENT_PANEL_SEGMENTS)[number];

const VIEW_TO_SEGMENT: Record<string, DocumentPanelSegment> = {
  chapters: 'chapters',
  analysis: 'analysis',
  storylines: 'storylines',
  scenes: 'scenes',
  characters: 'characters',
  locations: 'locations',
  technicalSheet: 'technical-sheet',
  export: 'export',
  share: 'share',
  versionHistory: 'version-history',
  stats: 'stats',
  settings: 'settings',
  suggestions: 'suggestions',
  comments: 'comments',
  chat: 'chat',
};

const SEGMENT_TO_VIEW: Record<string, string> = {
  chapters: 'chapters',
  analysis: 'analysis',
  storylines: 'storylines',
  scenes: 'scenes',
  characters: 'characters',
  locations: 'locations',
  'technical-sheet': 'technicalSheet',
  export: 'export',
  share: 'share',
  'version-history': 'versionHistory',
  stats: 'stats',
  settings: 'settings',
  suggestions: 'suggestions',
  comments: 'comments',
  chat: 'chat',
};

export function mainAreaViewToPanelSegment(view: string): DocumentPanelSegment | null {
  const segment = VIEW_TO_SEGMENT[view];
  return segment ?? null;
}

export function panelSegmentToMainAreaView(segment: string): string | null {
  return SEGMENT_TO_VIEW[segment] ?? null;
}

export function getDocumentPath(projectId: string | undefined, documentId: string): string {
  if (projectId) {
    return `/projects/${projectId}/documents/${documentId}`;
  }
  return `/documents/${documentId}`;
}

export function getDocumentPanelPath(
  projectId: string | undefined,
  documentId: string,
  view: string
): string {
  const segment = mainAreaViewToPanelSegment(view);
  if (!segment) {
    return getDocumentPath(projectId, documentId);
  }
  return `${getDocumentPath(projectId, documentId)}/${segment}`;
}

export function getCharacterDetailHref(
  projectId: string | undefined,
  documentId: string,
  characterId: string
): string {
  return `${getDocumentPanelPath(projectId, documentId, 'characters')}?characterId=${encodeURIComponent(characterId)}`;
}

export function resolveSectionDocumentId(
  currentDocumentId: string | undefined,
  mainDocumentId: string | null | undefined
): string | null {
  if (currentDocumentId && currentDocumentId !== 'new') {
    return currentDocumentId;
  }
  return mainDocumentId ?? null;
}

export function isValidPanelSegment(segment: string): segment is DocumentPanelSegment {
  return DOCUMENT_PANEL_SEGMENTS.includes(segment as DocumentPanelSegment);
}
